import { COUNTRY } from '@/core/country.js';
import store from '@/store';
import { fillDocument as fillDocumentAU } from './au';

function fillDocumentFactory() {
  const countryCode = store.state.onboarding?.countryCode;
  let doc;
  switch (countryCode) {
    case COUNTRY.AU:
      doc = fillDocumentAU;
      break;
    default:
      doc = fillDocumentAU;
      break;
  }
  return doc;
}

export function getUpdatedDocumentFields(document, changedField) {
  let doc = fillDocumentFactory();
  const updatedDocumentFields = doc(document, changedField);
  return updatedDocumentFields;
}

export function fillDocumentFields(fieldsToBeUpdated, document, newValue) {
  const dependentFields = document.fields.filter((field) =>
    fieldsToBeUpdated.includes(field.name)
  );
  const value = newValue;
  const valueObj = { unformatted: newValue, value: newValue };
  const updatedValue = dependentFields.map((field) => ({
    ...field,
    stringValue: value,
    value: value,
    valueObj: valueObj,
    fieldError: '',
  }));
  const fields = document.fields.map(
    (field) =>
      updatedValue.find((updated) => updated.name === field.name) || field
  );
  return fields;
}
